import { useLocation } from 'react-router-dom';
import { SettingsGeolocalisation, SettingsDatas, SettingsAlerts, SettingsFleet, SettingsBus } from '.';
import { useRef } from 'react';
import { getIcons } from '_helpers';

export { SettingsLayout }

/**
 * Composant générique qui utilise l'url afin de déterminer quel contenu utiliser
 * pour la div lattérale de settings
 * @returns 
 */
function SettingsLayout() {

  let { pathname } = useLocation();
  const refSettings = useRef(null);

  const alwaysOpen = pathname === "/geolocalisation" ? true : false;
  const iconName = pathname === "/geolocalisation" ? 'searchOutlined' : 'settingsOutlined';

  const getFilterComponent = () => {    
      switch (true) {
          case pathname === "/geolocalisation":
            return <SettingsGeolocalisation />;
          case pathname === "/donnees":
            return <SettingsDatas />;
          case pathname.startsWith("/donnees/flotte"):   
              return <SettingsFleet />;
          case pathname.startsWith("/donnees/bus"):   
              return <SettingsBus />;
          case  pathname === "/alertes":          
            return <SettingsAlerts />;
          case pathname === "/alertes/gestion":
          case pathname === "/filtres":
            return null;
          default:
            return null;
      }        
  };

  function handleClickBookmark() {
    refSettings.current.classList.toggle("is-settings-open");
  }

  return (
    <div id="settings-container"
      className={!alwaysOpen ? "is-settings-open" : ''}
      ref={refSettings}>
      <button className="bookmark">
        <img
          src={getIcons(iconName)}
          alt="bookmark"
          onClick={() => {
            handleClickBookmark("filter");
          }}
        />
      </button>
      {getFilterComponent()}
    </div>
  );
}
